import React from 'react';
import { FormInput } from '../../../components/merchants/FormInput';
import { SectionWrapper } from '../../../components/SectionWrapper';
import { useTranslation } from 'react-i18next';
import { useMerchants } from '../../../store/merchnts/merchants-context';
import { IModalWindow, ModalWindow } from '../../../components/modal/ModalWindow';
import { UpdateComponent } from '../../../components/merchants/MerchantPage/withMerchantDetails';
import { IAuthState } from '../../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../../setup';
import { checkRoles, CLAIMS } from '../../../utils/roles-helper';
import { MERCHANT_DEVELOPER_INPUTS } from '../../../constants/merchant/developers';

interface IDeveloperProps {
	isEditMode: boolean;
	setIsEditMode: (value:boolean) => void;
	isLoading: boolean;
	modalState: IModalWindow;
	closeModal: () => void;
	formik: any;
	onEditClick: () => void;
	onCancelClick?: () => void;
}

const MerchantDeveloperPage = (props: IDeveloperProps): JSX.Element => {
	const { isEditMode, setIsEditMode, isLoading, modalState, closeModal, formik, onEditClick, onCancelClick } = props;
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const { t } = useTranslation();
	const { merchantState: { isMerchantDataLoading, merchantData }} = useMerchants();

	const INPUTS = MERCHANT_DEVELOPER_INPUTS({ t });

	const showPlaceholder = !merchantData || typeof merchantData === 'object' && Object.keys(merchantData).length === 0 || typeof merchantData !== 'object';

	return (
		<>
			<SectionWrapper
				showPlaceholder={showPlaceholder}
				title={t('NEW_APPLICATION.DEVELOPER_INFORMATION')}
				sectionAdditionalClass="mb-5 min-height-200"
				isEditMode={isEditMode}
				setIsEditMode={setIsEditMode}
				onEditClick={onEditClick}
				onCancelClick={onCancelClick}
				loading={isLoading}
				pageLoading={isMerchantDataLoading}
				isCardBody
				isEditBlock={checkRoles(authUser, CLAIMS.SUPER_ADMIN_AND_ONLY_PARTNER_ADMIN) && !showPlaceholder}
			>
				<div className="row">
					{
						INPUTS.map(item => {
							return (
								<FormInput
									{...item}
									key={item.key}
									formik={formik}
									isEditMode={isEditMode}
								/>
							);
						})
					}
				</div>
			</SectionWrapper>
			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>
		</>
	);
};

export default UpdateComponent(MerchantDeveloperPage, 'developer-details');
